import { render, staticRenderFns } from "./VeHrChangePerson.vue?vue&type=template&id=8142dcf0&scoped=true"
import script from "./VeHrChangePerson.vue?vue&type=script&lang=js"
export * from "./VeHrChangePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8142dcf0",
  null
  
)

export default component.exports